import type { SortingState } from "@tanstack/react-table";
import { atom } from "jotai";

export const activeStockIdState = atom<string | undefined>(undefined);
export const stockSortState = atom<SortingState>([
  {
    id: "potentialRevenue",
    desc: true,
  },
]);
